import {
	SET_FORM_STATE,
	GET_FAILURES_DROPDOWNS,
	TOGGLE_OPTIONS_FAILURES_TRACKER_DIALOG,
	TOGGLE_OPTIONS_FAILURES_TRACKER_FORM,
	ADD_DROPDOWN_FIELD
} from '../actions/FailuresActions';

const initialState = {
	optionsFailuresTrackerDialogVisibility: false,
	optionsFailuresTrackerFormVisibility: false,
	dropdowns: [],
	newDropdownField: '',
	formState: {
		values: {
		},
		isValid: false,
		touched: {},
		errors: {},
	},
};

const failuresReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case GET_FAILURES_DROPDOWNS: {
						return {
							...state,
							dropdowns: action.dropdowns
						};
					}
					case TOGGLE_OPTIONS_FAILURES_TRACKER_DIALOG: {
						return {
							...state,
							optionsFailuresTrackerDialogVisibility: action.visible
						};
					}
					case TOGGLE_OPTIONS_FAILURES_TRACKER_FORM: {
						return {
							...state,
							optionsfailuresTrackerFormVisibility: action.visible,
							dropdownLabel: action.dropdownLabel,
							dropdownName: action.dropdownName,
							dropdownValue: action.dropdownValue,
							dropdownId: action.dropdownId
						};
					}
					case ADD_DROPDOWN_FIELD: {
						return {
							...state,
							newDropdownField: action.newDropdownField
						};
					}
					default: {
						return state;
					}
	}
};

export default failuresReducer;
